<template>
  <div
    ref="button"
    class="google-sign-in"
  />
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { googleSignInEnabled } from '@/auth/session'

const SCRIPT_ID = 'google-identity-service-script'

const loadScript = () => new Promise((resolve, reject) => {
  if (window.google?.accounts?.id) {
    resolve()
    return
  }
  const existing = document.getElementById(SCRIPT_ID)
  if (existing) {
    existing.addEventListener('load', resolve, { once: true })
    existing.addEventListener('error', reject, { once: true })
    return
  }
  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = 'https://accounts.google.com/gsi/client'
  script.async = true
  script.defer = true
  script.onload = resolve
  script.onerror = reject
  document.head.appendChild(script)
})

export default {
  props: {
    text: {
      type: String,
      default: 'continue_with',
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  mounted() {
    this.render()
  },

  methods: {
    notifyError(text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-center',
        props: {
          title: 'Error',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          text,
        },
      })
    },

    async render() {
      if (!googleSignInEnabled()) return
      try {
        await loadScript()
        if (!this.$refs.button || !window.google?.accounts?.id) return

        window.google.accounts.id.initialize({
          client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          callback: response => this.handleCredential(response),
        })
        window.google.accounts.id.renderButton(this.$refs.button, {
          theme: 'outline',
          size: 'large',
          shape: 'rectangular',
          width: Math.min(400, this.$refs.button.offsetWidth || 380),
          text: this.text,
          logo_alignment: 'center',
        })
      } catch (error) {
        this.notifyError('No fue posible cargar el acceso con Google.')
      }
    },

    async handleCredential(googleResponse) {
      if (this.loading) return
      const idToken = googleResponse?.credential
      if (!idToken) {
        this.notifyError('Google no devolvió una sesión válida; inténtalo de nuevo.')
        return
      }

      this.loading = true
      try {
        const payload = await this.$store.dispatch('auth/signInWithGoogle', { idToken })
        this.$emit('success', payload)
      } catch (error) {
        const messages = error?.response?.data?.messages
        this.notifyError(Array.isArray(messages) && messages.length ? messages.join(' ') : 'No fue posible entrar con Google.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.google-sign-in {
  display: flex;
  justify-content: center;
  min-height: 44px;
}
</style>
